/** `?walk=<url>`: a `.walk` fetched from a local server (Walk Bake's Preview Walk) instead of picked by hand. */

/** The absolute http(s) URL named by `?walk=`, or null when it is absent or not one we fetch. */
export function walkUrlFromSearch(search: string, base: string): URL | null {
  const raw = new URLSearchParams(search).get("walk");
  if (!raw) return null;
  try {
    const url = new URL(raw, base);
    return url.protocol === "http:" || url.protocol === "https:" ? url : null;
  } catch {
    return null;
  }
}

/** A file name for the walk from its URL path, e.g. `kitchen.walk`; used until walk.json gives the real name. */
export function walkFileName(url: URL): string {
  const last = decodeURIComponent(url.pathname.split("/").filter(Boolean).pop() ?? "");
  return last || "preview.walk";
}

export async function fetchWalk(url: URL): Promise<File> {
  let response: Response;
  try {
    response = await fetch(url, { cache: "no-store" });
  } catch {
    throw new Error(
      `Could not reach the walk at ${url.host}. The server must be running and allow this page to read it (CORS), and an https Player cannot read a plain-http server other than this computer.`,
    );
  }
  if (!response.ok) throw new Error(`The walk server answered ${response.status} for ${url.host}${url.pathname}.`);
  return new File([await response.blob()], walkFileName(url), { type: "application/zip" });
}

/** Takes `?walk=` out of the address so a reload or a shared link does not fetch it again by surprise; other parameters stay. */
export function withoutWalkParam(search: string): string {
  const params = new URLSearchParams(search);
  params.delete("walk");
  const rest = params.toString();
  return rest ? `?${rest}` : "";
}
